import { API_URL } from './config'

// RESPONSE EXAMPLE
// {
//   "total_items": 4,
//   "page_count": 1,
//   "items": [
//     {
//       "landing_id": "21085286190ffad1248d17c4135ee56f",
//       "token": "21085286190ffad1248d17c4135ee56f",
//       "response_id": "21085286190ffad1248d17c4135ee56f",
//       "landed_at": "2017-09-14T22:33:59Z",
//       "submitted_at": "2017-09-14T22:38:22Z",
//       "metadata": {
//         "user_agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/603.3.8 (KHTML, like Gecko) Version/10.1.2 Safari/603.3.8",
//         "platform": "other",
//         "referer": "https://user_id.typeform.com/to/lR6F4j",
//         "network_id": "responsdent_network_id",
//         "browser": "default"
//       },
//       "answers": [{
//         "field": {
//           "id": "hVONkQcnSNRj",
//           "type": "dropdown",
//           "ref": "my_custom_dropdown_reference"
//         },
//         "type": "text",
//         "text": "Job opportunities"
//       }]
//     }
//   ]
// }
export async function fetchResponses (formId) {
  try {
    const response = await fetch(`${API_URL}/responses/${formId}`)
    const data = await response.json()
    return data
  } catch (err) {
    console.error(err)
  }
  return null
}

export function parseResponses (responses = {}, form = {}) {
  const { items = [] } = responses
  const { fields: formFields = [] } = form
  const responseDates = {}

  try {
    items.forEach(({ answers, submitted_at: submittedAt }) => {
      const date = new Date(submittedAt).toDateString()
      if (!responseDates[date]) {
        responseDates[date] = {}
      }

      answers.forEach(answer => {
        const formField = formFields.find(({ ref }) => ref === answer.field.ref)
        if (!responseDates[date][answer.field.ref]) {
          responseDates[date][answer.field.ref] = {
            title: formField.title,
            answers: []
          }
        }
        responseDates[date][answer.field.ref].answers.push(answer[answer.type])
      })
    })
  } catch (err) {
    console.error(err)
  }

  return responseDates
}
